(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('RunnerRaceResumeDialogController', RunnerRaceResumeDialogController);

    RunnerRaceResumeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'RunnerRaceResume', 'Runner', 'RacePositions', 'RaceResume'];

    function RunnerRaceResumeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, RunnerRaceResume, Runner, RacePositions, RaceResume) {
        var vm = this;

        vm.runnerRaceResume = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.runners = Runner.query();
        vm.racepositions = RacePositions.query();
        vm.raceresumes = RaceResume.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.runnerRaceResume.id !== null) {
                RunnerRaceResume.update(vm.runnerRaceResume, onSaveSuccess, onSaveError);
            } else {
                RunnerRaceResume.save(vm.runnerRaceResume, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('liverunApp:runnerRaceResumeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.finishDate = false;
        vm.datePickerOpenStatus.startDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
